var $6835949b68a1fabf$exports = {};
$6835949b68a1fabf$exports = {
  "close": "\u05E1\u05D2\u05D5\u05E8",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u05D4\u05EA\u05E8\u05D0\u05D4");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u05D4\u05EA\u05E8\u05D0\u05D5\u05EA");
      }
    }), ".");
  }
};
export { $6835949b68a1fabf$exports as default };